import React from 'react';

export const AvatarSkeleton = ({ className = '' }) => (
  <div
    className={`w-8 h-8 rounded-full animate-pulse 
      bg-gray-300 dark:bg-gray-700 border border-white/20 
      backdrop-blur-md shadow-md ${className}`}
  />
);
